<template>
  <div
    class="ticket-list-item"
    :class="{
      'ticket-list-item--selected': selected,
      'ticket-list-item--disabled': disabled,
      'ticket-list-item--pressed': isPressed && !disabled,
      'ticket-list-item--filter': filterStyle,
    }"
    :style="{ '--accent-color': ticket.color }"
    @mousedown="onPressStart"
    @mouseup="onPressEnd"
    @mouseleave="onPressEnd"
    @click="handleClick"
  >
    <div class="ticket-list-item__status">
      <div
        :class="[
          'status-indicator',
          disabled
            ? 'status-indicator--disabled'
            : selected
              ? 'status-indicator--selected'
              : isPressed
                ? 'status-indicator--pressed'
                : 'status-indicator--default',
        ]"
      >
        <v-icon v-if="selected" color="white" size="12">mdi-check</v-icon>
        <div v-else class="status-indicator__hover-icon" />
      </div>
    </div>

    <div class="ticket-list-item__content">
      <div
        class="ticket-list-item__title"
        :class="{
          'ticket-list-item__title--disabled': disabled,
          'ticket-list-item__title--truncate': truncateTitle,
        }"
      >
        {{ workflowLabel(ticket.name) }}
      </div>
      <div class="ticket-list-item__bottom-row">
        <div
          class="ticket-list-item__price"
          :class="{ 'ticket-list-item__price--disabled': disabled }"
        >
          <span class="ticket-list-item__price-amount">{{ workflowLabel(ticket.price) }}</span>
          <span class="ticket-list-item__price-currency">{{ workflowLabel(ticket.currency) }}</span>
        </div>

        <div
          v-if="ticket.bundleOffer && ticket.bundleOffer.availableQuantity > 0"
          class="ticket-list-item__badge"
        >
          <img src="/assets/tickets-chip.svg" :alt="adminText('workflowsAll.tickets_5c622a5', 'Tickets')" width="11.642px" height="12.084px">
          <div class="ticket-list-item__badge-text">
            {{ workflowLabel(ticket.bundleOffer.quantityInterval) }}+{{ workflowLabel(ticket.bundleOffer.freeQuantity) }} {{ adminText('workflowsAll.gratis_92fc95b', 'gratis') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
// @ts-nocheck
export default {
  mixins: [WorkflowDisplay],
  name: 'ticket-dropdown-item',
  props: {
    ticket: {
      type: Object,
      default: () => {},
    },
    /**
     * Whether the item is currently selected.
     */
    selected: {
      type: Boolean,
      default: false,
    },
    /**
     * When disabled, visuals are muted and click events are ignored.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * When true, ticket.name is displayed on a single line with ellipsis overflow.
     */
    truncateTitle: {
      type: Boolean,
      default: false,
    },
    filterStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPressed: false,
    }
  },
  methods: {
    onPressStart() {
      if (this.disabled) return
      this.isPressed = true
    },
    onPressEnd() {
      this.isPressed = false
    },
    handleClick(event) {
      if (this.disabled) {
        event.stopPropagation()

        return
      }

      this.$emit('click', event)
    },
  },
}
</script>

<style scoped>
.ticket-list-item--filter {
  padding: 10px 16px !important;
  gap: 8px !important;
}

.ticket-list-item--filter:hover {
  background: #e6f1f8 !important;
}

.ticket-list-item--filter .ticket-list-item__status {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.ticket-list-item--filter .status-indicator {
  width: 20px;
  height: 20px;
  border: none;
  background: var(--accent-color);
}

.ticket-list-item--filter .ticket-list-item__content {
  min-width: 0;
  gap: 0;
}

.ticket-list-item--filter .ticket-list-item__title {
  color: #666;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  overflow-wrap: anywhere;
}

.ticket-list-item--filter .ticket-list-item__price {
  font-weight: 700;
  letter-spacing: 0;
}

.ticket-list-item--filter .ticket-list-item__bottom-row {
  flex-wrap: wrap;
}

.ticket-list-item {
  width: 100%;
  display: flex;
  padding: 0.5rem 0.38rem;
  align-items: flex-start;
  gap: 0.375rem;
  background-color: #ffffff;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease, transform 0.08s ease;
}

.ticket-list-item:hover:not(.ticket-list-item--disabled):not(.ticket-list-item--selected) {
  background-color: #f5f5f5;
}

.ticket-list-item--pressed:not(.ticket-list-item--disabled) {
  background-color: #e0e0e0;
  transform: translateY(1px);
}

.ticket-list-item--selected:not(.ticket-list-item--disabled) {
  background-color: #ffffff;
}

.ticket-list-item--disabled {
  cursor: default;
  background-color: #ffffff;
}

.ticket-list-item__status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-indicator {
  width: 13.333px;
  height: 13.333px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-indicator--default {
  border: 1px solid var(--accent-color);
  background-color: transparent;
}

.status-indicator--pressed {
  border: 1px solid var(--accent-color);
  background-color: var(--accent-color);
}

.status-indicator--selected {
  border: 1px solid var(--accent-color);
  background-color: var(--accent-color);
}

.status-indicator--disabled {
  border: 1px solid #d9d9d9;
  background-color: transparent;
}

.ticket-list-item__content {
  max-width: 90%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.ticket-list-item__title {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 1.05rem */
}

.ticket-list-item__title--truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ticket-list-item__title--disabled {
  color: #b3b3b3;
}

.ticket-list-item__bottom-row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.ticket-list-item__price {
  color: #333;
  text-align: right;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.02625rem;
  text-transform: uppercase;
}

.ticket-list-item__price--disabled {
  color: #b3b3b3;
}

.ticket-list-item__price-amount {
  margin-right: 0.25rem;
}

.ticket-list-item__badge {
  display: flex;
  height: 1.125rem;
  padding: 0 0.5rem 0 0.375rem;
  align-items: center;
  gap: 0.25rem;
  border-radius: 2rem;
  background-color: #e5f4ff;
}

.ticket-list-item__badge-icon svg {
  width: 0.875rem;
  height: 0.875rem;
  fill: #0277bd;
}

.ticket-list-item__badge-text {
  color: #0277bd;
  font-family: 'Raleway', sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}

.status-indicator__hover-icon {
  width: 6.66667px;
  height: 6.66667px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: var(--accent-color);
  display: none;
}

.ticket-list-item:not(.ticket-list-item--disabled):not(.ticket-list-item--selected):hover
  .status-indicator__hover-icon {
  display: block;
}
</style>
